export const Header = ({ data, small = false }) => {
    return (
        <>
            {!small ? (
                <header id="header">
                    <div className="intro">
                        <div className="overlay">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="logo">
                                        {data ? <img src={data.logo} alt="Logo" /> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            ) : (
                <header id="header">
                    <div className="intro-small">
                        <div className="overlay">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="logo-small">
                                        {data ? <img src={data.logo} alt="Logo" /> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            )}
        </>
    );
};